export const calcInvoiceDiscountFromProducts = ({
  products,
  procedures,
  hasDiscountInProducts,
  initialInvoice
}) => {
  let amountCents = 0;
  let percentages = 0;

  products?.forEach((product) => {
    let discount = product?.discount;

    // update discount of old versions that had discount only in invoice level
    if (!discount && !hasDiscountInProducts && initialInvoice?.discount) {
      discount = getProductDiscountFromInvoice({
        productCost: product.amount_cents,
        invoice: initialInvoice,
        products,
        procedures
      });
    }

    const { amount_cents = 0, percentage = 0 } = discount || {};

    amountCents += amount_cents;
    percentages += percentage;
  });

  procedures?.forEach((service) => {
    let discount = service?.discount;

    // update discount of old versions that had discount only in invoice level
    if (!discount && !hasDiscountInProducts && initialInvoice?.discount) {
      discount = getProductDiscountFromInvoice({
        productCost: service?.total_cost_cents,
        invoice: initialInvoice,
        products,
        procedures
      });
    }

    const { amount_cents = 0, percentage = 0 } = discount || {};

    amountCents += amount_cents;
    percentages += percentage;
  });

  return { amount_cents: amountCents, percentage: percentages, type: 'amount' };
};

export const getProductDiscountFromInvoice = ({
  productCost = 0,
  invoice,
  products,
  procedures
}) => {
  const invoiceDiscountAmount = invoice?.discount?.amount_cents;

  let productsTotal = 0; // sum of all products
  let productsDiscount = 0; // discount separated from invoice discount

  if (invoiceDiscountAmount > 0) {
    productsTotal =
      products?.reduce((acc, curr) => {
        acc += +curr.amount_cents || 0;
        return acc;
      }, 0) || 0;

    const proceduresTotal =
      procedures?.reduce((acc, curr) => {
        acc += +(curr.pt_balance ?? curr.total_cost_cents ?? 0) || 0;

        return acc;
      }, 0) || 0;

    const totalCents = productsTotal + proceduresTotal;

    if (totalCents > 0) {
      const discountForCents = invoiceDiscountAmount / totalCents;

      productsDiscount = productsTotal * discountForCents;
    }
  }

  const productDiscount = +((productCost / productsTotal) * productsDiscount) || 0;
  const productPercentage = +((productDiscount / productCost) * 100) || 0;

  return {
    amount_cents: productDiscount,
    percentage: productPercentage,
    type: 'amount'
  };
};

// calc tax for inv
export const calculateInvoiceTaxFromItems = ({ products, procedures }) => {
  let productsTaxAmount = 0;
  let proceduresTaxAmount = 0;

  products?.forEach((curr) => {
    const amount = Number(curr.amount_cents);
    const tax = (Number(curr.local_tax_rate) + Number(curr.state_tax_rate)) / 100;

    productsTaxAmount += amount * tax;
  });

  procedures?.forEach((curr) => {
    const amount = Number(curr.pt_balance ?? curr.total_cost_cents ?? 0);
    const tax = (Number(curr.local_tax_rate) + Number(curr.state_tax_rate)) / 100;

    proceduresTaxAmount += amount * tax;
  });

  const invoiceTaxAmount = (productsTaxAmount + proceduresTaxAmount) / 100;

  return invoiceTaxAmount;
};
